import { render, staticRenderFns } from "./ModalNotifications.vue?vue&type=template&id=58566dcd&scoped=true"
import script from "./ModalNotifications.vue?vue&type=script&lang=js"
export * from "./ModalNotifications.vue?vue&type=script&lang=js"
import style0 from "./ModalNotifications.vue?vue&type=style&index=0&id=58566dcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58566dcd",
  null
  
)

export default component.exports